// import 'swiper/swiper.min.css';
import { React, useEffect } from 'react';
import '../src/assets/icons/font-awesome.css';
import './App.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import AOS from 'aos';

// 1. Added useLocation to the react-router-dom import
import { Route, Routes, useLocation } from 'react-router-dom';

import routes from './pages/index';

function App() {
    // 2. Initialize the location hook to listen for page changes
    const location = useLocation();

    // Your existing AOS animation initialization
    useEffect(() => {
        AOS.init({
          duration : 2000
        }); 
    }, []);

    // 3. New useEffect hook specifically for Google Analytics tracking
    useEffect(() => {
        if (window.gtag) {
            window.gtag('config', 'G-BS1KQVJEX0', {
                page_path: location.pathname,
            });
        }
    }, [location]); // This array ensures it runs every time the route/page changes

    return (
        <Routes>
            {
            routes.map((data, index) => (
                <Route exact={true} path={data.path} element={data.component} key={index} />
            ))
            }
        </Routes>
    );
}

export default App;
